import { countryTaxTypes } from '../../shared/constants';

export const CountryTaxTypes = [
  { value: countryTaxTypes.US1, label: 'US1' },
  { value: countryTaxTypes.US2, label: 'US2' },
  { value: countryTaxTypes.XX1, label: 'xx1' },
];

export const GAAPs = [
  { value: 'P', label: 'P' },
];

export const G2Ss = [
  { value: 'G', label: 'G' },
];

export const Lines = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
];

export const Directions = [
  { value: '1', label: '1' },
  { value: '-1', label: '-1' },
];
